import { render } from "./PerkConfigFormField.vue?vue&type=template&id=23a5595b&scoped=true"
import script from "./PerkConfigFormField.vue?vue&type=script&lang=js"
export * from "./PerkConfigFormField.vue?vue&type=script&lang=js"

import "./PerkConfigFormField.vue?vue&type=style&index=0&id=23a5595b&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a5595b"]])

export default __exports__